import { Box, BoxProps } from "@mui/material";
import React from "react";

interface Props {
  children: React.ReactNode;
}
const PaddedBox = ({ children, ...props }: Props & BoxProps): JSX.Element => {
  return (
    <Box sx={{ p: { xs: 1, md: 3 } }} {...props}>
      {children}
    </Box>
  );
};

export default PaddedBox;
